import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { initialize, reset as resetForm } from 'redux-form';
import _ from 'lodash';
import { recebedorParaFormulario } from './gateway/recebedorFormulario';
import types from './types';

const URL_UPDATE_PROFILE = `${BASE_API}/user-establishment-profile`;
const URL_SIGNUP_PAGARME = `${BASE_API}/gateway-digital-accounts`;

/** Com `campos` (validação do backend), mostra o que falta em vez do resumo. */
const mensagemDeErroDoCadastro = (dados) =>
  Array.isArray(dados?.campos) && dados.campos.length
    ? dados.campos.map((campo) => campo.mensagem).join(' ')
    : `${dados.message}`;

export const setDetail = (values) => {
  return (dispatch) => {
    dispatch({
      type: types.LIST_LOAD,
      payload: true,
    });
    const initialValues = {
      ...values,
    };
    dispatch([
      {
        type: types.ITEM_DETAIL,
        payload: { data: values },
      },
      initializeForm(initialValues),
      reset(),
    ]);
  };
};

export const getPagarmeDetail = (id, email) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.PAGARME_DATA_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_SIGNUP_PAGARME}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        if (!_.isArray(response.data)) {
          const emailDoUsuario =
            email || (typeof getState === 'function' ? getState()?.auth?.user?.email : undefined);
          const { recebedor, formulario } = recebedorParaFormulario(response.data, {
            email: emailDoUsuario,
          });
          dispatch([
            {
              type: types.PAGARME_DATA_FETCHED,
              payload: { data: formulario, recebedor },
            },
            initialize('GatewayForm', formulario),
          ]);
        } else {
          dispatch({
            type: types.PAGARME_DATA_LOAD,
            payload: false,
          });
        }
      })
      .catch((e) => {
        try {
          dispatch({
            type: types.PAGARME_DATA_LOAD,
            payload: false,
          });
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data.message}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          console.log(error);
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const initializeForm = (values) => {
  return initialize('ProfileForm', values);
};

export const reset = () => {
  return resetForm('ProfileForm');
};

export const updateProfile = (values) => {
  return (dispatch) => {
    axios
      .post(URL_UPDATE_PROFILE, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
      })
      .catch((e) => {
        dispatch({
          type: 'SNACKBAR',
          payload: {
            message: `Erro ${e.response.data.messages[0]}`,
            variant: 'error',
            open: true,
          },
        });
      });
  };
};

export const saveGatewayInfo = (values) => {
  return (dispatch) => {
    axios
      .post(URL_SIGNUP_PAGARME, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const putGatewayInfo = (values, id) => {
  return (dispatch) => {
    axios
      .put(`${URL_SIGNUP_PAGARME}/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: `Você atualizou a seu perfil com sucesso`,
              variant: 'success',
              open: true,
            },
          },
        ]);
        window.location.reload();
      })
      .catch((e) => {
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: mensagemDeErroDoCadastro(e.response.data),
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};
